export default __webpack_public_path__ + "static/Gilroy-SemiBold-9a372547fba565263e1f4066ba40f165.woff2";